import { ArrowLeft } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';

import { RETURN_PARAM, returnLabel, safeReturn } from '../../lib/bureau/crmLinks';

/**
 * « Retour à la mission » over a tool's page opened from the Bureau (mock-up « Fiche »): the page
 * carries where it came from in its URL (`retour`, set by « Ouvrir dans le CRM »), and the way back
 * shows as long as it is there. Nothing otherwise — a page reached from the tools has no way back
 * to draw.
 */
export function ReturnToBureau() {
  const [params] = useSearchParams();
  const back = safeReturn(params.get(RETURN_PARAM));
  if (!back) return null;
  return (
    <div className="flex h-10 shrink-0 items-center border-b border-desk-line bg-white px-3 lg:px-5">
      <Link
        to={back}
        className="inline-flex h-8 items-center gap-1.5 rounded-lg px-2 text-sm font-medium text-desk-soft transition-colors hover:bg-desk-subtle hover:text-desk-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-desk-focus"
      >
        <ArrowLeft size={16} strokeWidth={1.75} aria-hidden="true" />
        {returnLabel(back)}
      </Link>
    </div>
  );
}
